import { storeOrUpdateWorker } from '@/api/worker'
import { getCorporations, getTeams, getKvData} from '@/api/open'

export default {
    components: {},
    props: {
        showForm: {
            type: Boolean,
            required: true
        },
        model: {
            type: Object,
            default: () => null
        }
    },
    data() {
        return {
            labelCol: {span: 5},
            wrapperCol: {span: 17},
            medias: [],
            corporations: [],
            loading: false,
            rules: {
                username: [{required: true, message: '请填写优化师名称', trigger: 'change'}],        
                corporation_id: [{required: true, message: '请选择主体', trigger: 'change'}],        
                type: [{required: true, message: '请选择身份类型', trigger: 'change'}],
            },
            platforms:[],
            teams: [],
            types: [
                {id: 1, name: '优化师'},
                {id: 2, name: '剪辑'}
            ],
            emails: [],
            status: [{id:1, name:"在职"}, {id:2, name:"离职"}],
            businessTypes: [{id:1, name:"快手分销"}, {id:2, name:"快手番茄代投"}],
        }
    },
    computed: {
        actType() {
            return this.model.id ? '修改' : '添加'
        }
    },
    mounted() {
        getCorporations().then(res=>{ 
            this.corporations = res.data.list 
            if (this.corporations.length > 0) {
                // 主体默认设置为最后一个
                this.model.corporation_id = this.corporations[this.corporations.length - 1].id
                this.getjuliangEmails()
            }
        })

        getTeams().then(res => {this.teams = res.data.list || []})
    },
    watch: {},
    methods: {
        submit() {
            this.$refs.form.validate(valid => {
                if (!valid) {
                    return false
                }
                this.storeOrUpdate()
            })
        },
        storeOrUpdate() {
            const data = Object.assign({}, this.model)
            this.loading = true
            storeOrUpdateWorker(data).then(res => {
                this.$message.destroy()
                if (res && res.code === 0) {
                    this.$message.success(this.model.id > 0 ? '修改成功' : '添加成功')
                    this.$emit('success')
                    this.close()
                } else {
                    this.$message.error(res.message)
                }
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        close() {
            this.$refs.form.resetFields()
            this.$emit('update:showForm', false)
        },
        getjuliangEmails(){
            getKvData({corporation_id:this.model.corporation_id, type:5, flag:"getName"}).then(res=>{ this.emails = res.data.list || {} })
        }
    }
}
